import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  FontAwesomeIcon
} from "@fortawesome/vue-fontawesome";
import {
  fas
} from '@fortawesome/free-solid-svg-icons'
import {
  library
} from '@fortawesome/fontawesome-svg-core'
// Auth0
import {
  domain,
  clientId,
  audience
} from "../auth_config.json";
import {
  Auth0Plugin
} from "./auth";

import VueShowdown from 'vue-showdown'

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    router.push(
      appState && appState.targetUrl ?
      appState.targetUrl :
      window.location.pathname
    );
  }
});

Vue.use(VueShowdown, {
  options: {
    emoji: true,
    openLinksInNewWindow: true,
  }
})
/*
 * Ofte brukte komponenter importeres globalt så vi slipper å importere dem
 * overalt hvor vi trenger dem.
 */
import PrimaryButton from "@/components/Buttons/PrimaryButton.vue";
import LinkButton from "@/components/Buttons/LinkButton.vue";
Vue.component(PrimaryButton.name, PrimaryButton);
Vue.component(LinkButton.name, LinkButton);


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')